import { useState } from "react";
import IconButton from "@mui/material/IconButton";
import Paper from "@mui/material/Paper";
import Stack from "@mui/material/Stack";
import Tab from "@mui/material/Tab";
import Tabs from "@mui/material/Tabs";
import Tooltip from "@mui/material/Tooltip";
import Typography from "@mui/material/Typography";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { useDispatch, useSelector } from "react-redux";
import { setAlunoTurma } from "./actions/actions";
import AlunoTurmaForm from "./AlunoTurmaForm";
import AlunoTurmaFormList from "./AlunoTurmaFormList";

const UM_ALUNO = "um-aluno";
const POR_LISTA = "por-lista";

const AlunoTurmaFormContainer = () => {
  const dispatch = useDispatch();
  const alunoTurma = useSelector((state) => state.alunoTurma);
  const [aba, setAba] = useState(UM_ALUNO);
  const eNovo = alunoTurma?.eNovo;
  const fechar = () => dispatch(setAlunoTurma(null));

  return (
    <Paper variant="outlined" sx={{ borderRadius: 2, p: 2.5 }}>
      <Stack direction="row" alignItems="center" spacing={1} mb={eNovo ? 1 : 2.5}>
        <Tooltip title="Voltar para a lista">
          <IconButton edge="start" onClick={fechar}>
            <ArrowBackIcon />
          </IconButton>
        </Tooltip>
        <Typography variant="subtitle1" fontWeight={600}>
          {eNovo ? "Adicionar Alunos à Turma" : "Editar Aluno na Turma"}
        </Typography>
      </Stack>

      {eNovo && (
        <Tabs value={aba} onChange={(event, value) => setAba(value)} sx={{ mb: 2.5, borderBottom: 1, borderColor: "divider" }}>
          <Tab value={UM_ALUNO} label="Um aluno" />
          <Tab value={POR_LISTA} label="Vários por código" />
        </Tabs>
      )}

      {eNovo && aba === POR_LISTA ? <AlunoTurmaFormList onAdded={fechar} /> : <AlunoTurmaForm />}
    </Paper>
  );
};

export default AlunoTurmaFormContainer;
